import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { ProductModelResponse } from '../../../../pages/products/products.Model'
import { getActiveCompany, getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { ProductModel } from '../../model/contracts'
import { ConceptPriceModel } from '../concepts/model/concepts'
import {
  Product,
  ProductConceptPriceModel,
  ProductPriceModel,
  ProductPriceModelPatch,
  ProductPriceModelPost
} from './model/products'
import { CreateProductRequest } from './model/products.request.model'
import { mapProductModelToUpdateProductRequest } from './products.request.mapper'

export const apiFetchProducts = async ({
  clientType,
  commodity,
  companyId,
  includeInactives
}: {
  clientType: number
  commodity: number
  companyId?: number
  includeInactives: boolean
}): Promise<Product[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/products/FetchFilteredProducts?clientType=${clientType}&commodity=${commodity}&companyId=${companyId}&includeInactives=${includeInactives}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPostProduct = async (product: ProductModel): Promise<ProductModelResponse> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  const activeCompany = getActiveCompany()?.id
  const request: CreateProductRequest = { ...product, companyId: activeCompany }

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Products`, request).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchProductById = async (id: number): Promise<ProductModelResponse> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/products/${id}`).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiUpdateProduct = async (product: ProductModel): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  const request = mapProductModelToUpdateProductRequest(product)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Products/UpdateProduct`, request).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiUpdateProductDetail = async (product: ProductModel): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  const request = mapProductModelToUpdateProductRequest(product)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Products/UpdateProductDetail`, request).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchProductPriceComponents = async (
  productId: number
): Promise<ProductPriceModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Products(${productId})/Prices`).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchProductPriceComponentsWithDummyExpression = async (
  productId: number
): Promise<ProductPriceModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Products(${productId})/PricesWithDummyExpression`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPostProductPriceComponent = async (
  productId: number,
  priceComponentId: number,
  request: ProductPriceModelPost
): Promise<ProductPriceModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/products(${productId})/prices(${priceComponentId})`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPatchProductPriceComponent = async (
  id: number,
  request: ProductPriceModelPatch
): Promise<ProductPriceModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.patch(`${apiSuffixUrl}/api/products/prices(${id})`, request).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiDeleteProductPriceComponent = async (id: number): Promise<Object> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(`${apiSuffixUrl}/api/products/prices(${id})`).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

// Weighted Type

export const apiGetWeightedTypeListByBreakdownType = async (
  breakdownTypeId: number
): Promise<number[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Products/GetWeightedTypeListByBreakdownType?breakdownType=${breakdownTypeId}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchProductConceptPriceById = async (
  productId: number
): Promise<ConceptPriceModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/products/GetProductConceptPrices?productId=${productId}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPostProductConceptPrice = async (
  request: ProductConceptPriceModel
): Promise<ProductConceptPriceModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/products/PostProductConceptPrice`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiDeleteConceptPrice = async (id: number): Promise<Object> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(`${apiSuffixUrl}/api/products/DeleteConceptPrice(${id})`).then(
    response => {
      if (response.data) {
        return response.data
      }
    }
  )
}
